export default __webpack_public_path__ + "static/media/nimes.1017ce93.png";